module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-foot"
  }, [_c('nav', {
    staticClass: "tabs is-boxed is-centered"
  }, [_c('ul', _vm._l((_vm.tabs), function(tab) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": tab.path
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: tab.icon
    })]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(tab.title) + " ")])])], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7fcd1a87!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hero/hero-foot.vue
// module id = 279
// module chunks = 2